<template lang="html">
  <div>
    <div class="alert alert-danger" v-if="errors.length > 0">
      <ul>
        <li v-bind:key="index" v-for="(error, index) in errors">
          {{ error }}
        </li>
      </ul>
    </div>
    <b-form-group :label="$t('displayCoupon.code')" label-for="couponCode">
      <b-form-input id="couponCode" v-model="coupon.code"></b-form-input>
    </b-form-group>
    <b-form-group :label="$t('displayCoupon.value')" label-for="value" id="value">
      <b-form-radio v-model="picked" id="price" value="price">{{$t('displayCoupon.price')}}</b-form-radio>
      <b-form-radio v-model="picked" id="percent" value="percent">{{$t('displayCoupon.percentage')}}</b-form-radio>
    </b-form-group>
    <b-form-group :label="$t('displayCoupon.price')" label-for="price" v-if="picked == 'price'">
      <b-form-input id="price" type="number" v-model.number="coupon.price" min="0" step="1"></b-form-input>
    </b-form-group>
    <b-form-group :label="$t('displayCoupon.percentage')" label-for="percent" v-else-if="picked == 'percent'">
      <b-form-input id="percent" type="number" v-model.number="coupon.percent" min="0" max="100"></b-form-input>
    </b-form-group>
    <div>
      <label for="expiry">{{$t('displayCoupon.expiry')}}</label>
      <flatpickr class="form-control" :placeholder="$t('dateTime.date')" id="expiry" :options="expiryOptions"
        v-model="expiry"></flatpickr>
    </div>
    <b-form-group :label="$t('displayCoupon.quantity')" label-for="quantity">
      <b-form-input type="number" id="quantity" v-model="coupon.quantity" :disabled="coupon.unlimited"></b-form-input>
      <b-form-checkbox id="unlimited" v-model="coupon.unlimited" value="true">
        {{$t('displayCoupon.unlimited')}}
      </b-form-checkbox>
    </b-form-group>
    <b-button variant="primary" @click="create()">{{$t('buttons.createCoupon')}}</b-button>
  </div>
</template>

<script>
import Flatpickr from '@/components/Flatpickr'
export default {
  components: {
    Flatpickr
  },
  props: {
    show: {
      type: Boolean,
      required: true
    }
  },
  data () {
    return {
      coupon: {
        unlimited: true,
        price: 0,
        percent: 0,
        expiry: 0,
        code: ''
      },
      expiry: '',
      expiryOptions: {
        dateFormat: 'Y-m-d',
        altInput: true,
        altFormat: 'd-m-Y',
        altInputClass: 'form-control',
        allowInput: true,
        disableMobile: true
      },
      picked: 'price',
      errors: [],
      validation: true
    }
  },
  methods: {
    close () {
      this.coupon = {
        unlimited: true
      }
      this.picked = 'price'
      this.$emit('update')
    },
    create () {
      if (this.picked === 'price') {
        delete this.coupon.percent
      }
      if (this.picked === 'percent') {
        delete this.coupon.price
      }

      if (this.coupon.unlimited) {
        delete this.coupon.quantity
      }

      this.coupon.expiry = this.expiry
      this.validateMe()
      if (this.validation) {
        if (this.picked === 'percent') {
          this.coupon.percent = this.coupon.percent / 100
        }
        this.coupon.code = this.coupon.code.toUpperCase()
        this.$axios.post('v1/displays/' + this.$route.params.displayId + '/coupons', this.coupon).then(
          () => {
            this.close()
          },
          () => {
            this.$notifications.add({
              title: 'Error',
              type: 'danger',
              body: this.$t('notifications.couponExists'),
              timeout: true
            })
          }
        )
      }
    },
    validateMe () {
      this.errors = []
      this.validation = true
      if (this.picked === 'price') {
        this.lengthTest(this.coupon.price, 'Coupon Price', 1)
        this.integerTest(this.coupon.price, 'Coupon Price')
      } else {
        this.lengthTest(this.coupon.percent, 'Coupon percentage', 1, 100)
      }
      this.stringTest(this.coupon.code, 'Coupon Code', 255)
      if (this.coupon.unlimited === false) {
        this.lengthTest(this.coupon.quantity, 'Coupon Quanitity', 1)
        this.integerTest(this.coupon.quantity, 'Coupon Quanitity')
      }
      this.stringTest(this.coupon.expiry, 'Coupon Expiry', 10)
    },
    stringTest (value, input, max) {
      if (!value) {
        this.errors.push(input + ' is a required input')
        this.validation = false
      } else if (value.length > max) {
        this.errors.push(input + ' can only be a maxiumum of ' + max + ' characters')
        this.validation = false
      }
    },
    lengthTest (value, input, min, max) {
      if (!value) {
        this.errors.push(input + ' is a required input')
        this.validation = false
        return
      }
      if (min !== undefined) {
        if (value < min) {
          this.errors.push(input + ' has to be a minimum of ' + min)
          this.validation = false
          return
        }
      }
      if (max !== undefined) {
        if (value > max) {
          this.errors.push(input + ' can only be a maximum of ' + max)
          this.validation = false
          return
        }
      }
    },
    integerTest (value, input) {
      if (value % 1 !== 0) {
        this.errors.push(input + ' can only be a whole number')
        this.validation = false
      }
    }
  },
  watch: {
    'coupon.price': function () {
      if (this.coupon.price < 0) {
        this.coupon.price = -this.coupon.price
      }
    }
  }
}
</script>

<style lang="scss">
</style>
